import { useEffect } from "react";
import { type ErrorComponentProps } from "@tanstack/react-router";
import * as Sentry from "@sentry/react";
import { isAxiosError } from "axios";
import { SignInError } from "@/app/lib/errors/SignInError";
import { NoNetworkConnectionPageError } from "./NoNetworkConnectionPageError";
import { GeneralPageError } from "./GeneralPageError";
import { SignInErrorMessage } from "./SignInErrorMessage";
import { SnackbarProvider } from "@/app/lib/context/SnackbarContext";
import { CommonTrackingEvents, rudderAnalytics } from "@/app/lib/rudderstack";

export const DefaultErrorComponent = ({ error }: ErrorComponentProps) => {
  useEffect(() => {
    Sentry.captureException(error);
  }, [error]);

  useEffect(() => {
    rudderAnalytics.track(CommonTrackingEvents.UNEXPECTED_CLIENT_ERROR);
  }, []);

  return (
    <SnackbarProvider>
      {isAxiosError(error) && error.code === "ERR_NETWORK" ? (
        <NoNetworkConnectionPageError />
      ) : error instanceof SignInError ? (
        <SignInErrorMessage error={error} />
      ) : (
        <GeneralPageError />
      )}
    </SnackbarProvider>
  );
};
